import type { Halloween2026Variant } from '../utils/get-halloween-2026-variant';

export const HALLOWEEN_2026_CTA_LABEL = 'Save Now';
export const HALLOWEEN_2026_EYEBROW_LABEL = 'ENDS SOON';
export const HALLOWEEN_2026_HEADLINE_PREFIX = 'Halloween Sale:';

export const HALLOWEEN_2026_COLORS = {
  accent: 'orange.500',
  border: 'purple.700',
  cta: 'orange.700',
  ctaHover: 'orange.900',
  dividerGradient: 'linear(to-r, purple.300, transparent)',
  eyebrow: 'purple.300',
  subtitle: 'grey.200',
} as const;

const ASSET_DIR = '/images/promotions/halloween-2026';

export const HALLOWEEN_2026_ASSETS = {
  catalogBg: `${ASSET_DIR}/catalog-bg.webp`,
  catalogBgMobile: `${ASSET_DIR}/catalog-bg-mobile.webp`,
  experienceAtfBg: `${ASSET_DIR}/experience-atf-bg.webp`,
  experienceAtfBgMobile: `${ASSET_DIR}/experience-atf-bg-mobile.webp`,
  homepageBg: `${ASSET_DIR}/homepage-bg.webp`,
  homepageBgMobile: `${ASSET_DIR}/homepage-bg-mobile.webp`,
} as const;

export const HALLOWEEN_2026_CHECKOUT_HREF: Record<Halloween2026Variant, string> = {
  full: '/checkout/individual/4month/credit-card',
  low: '/checkout/individual/annually/credit-card',
};

type Halloween2026VariantCopy = {
  headlineOffer: string;
  /** Mobile homepage breaks after "Halloween Sale:" only when the offer is short enough to sit on its own line. */
  homepageHeadlineBreaksOnMobile: boolean;
  homepageSubtitle: string;
  catalogSubtitle: string;
  experienceOffer?: string;
  experienceSubtitle: string;
};

const EXPERIENCE_SUBTITLE = "Don't ghost your goals, build future\u2011ready tech skills for less.";

export const HALLOWEEN_2026_VARIANTS: Record<Halloween2026Variant, Halloween2026VariantCopy> = {
  full: {
    headlineOffer: '50% OFF all programs',
    homepageHeadlineBreaksOnMobile: true,
    homepageSubtitle: "No tricks. Just half off the AI & tech skills you've been meaning to build.",
    catalogSubtitle: 'Give your skills a treat. Explore AI, data & more.',
    experienceOffer: '50% off',
    experienceSubtitle: EXPERIENCE_SUBTITLE,
  },
  low: {
    headlineOffer: 'Save on every program',
    homepageHeadlineBreaksOnMobile: false,
    homepageSubtitle: "No tricks. Just a limited-time offer on the AI & tech skills you've been meaning to build.",
    catalogSubtitle: 'Give your skills a treat. Explore AI, data & more.',
    experienceSubtitle: EXPERIENCE_SUBTITLE,
  },
};

export function getHalloween2026CheckoutHref(variant: Halloween2026Variant, promoCode?: string | null): string {
  const href = HALLOWEEN_2026_CHECKOUT_HREF[variant];
  if (!promoCode) {
    return href;
  }
  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}coupon=${encodeURIComponent(promoCode)}`;
}
